import { CharacterIcon, mapCharacterIconToFilePath } from './CharacterIcon';
import {
  UninitializedCharacter,
  Character,
  CharacterOrientation,
} from './types';

// consts

export const SVG_CANVAS_WIDTH = 600;
export const SVG_CANVAS_HEIGHT = 375;

export const CHAR_INITIAL_WIDTH = 80;
export const CHAR_IMAGE_TEXT_OFFSET = 20;
export const CHAR_MIN_SIZE = 20;
export const CHAR_START_POSITIONS_INITIAL_X = 25;
export const CHAR_START_POSITIONS_INITIAL_Y = SVG_CANVAS_HEIGHT / 2 - 50;
export const CHAR_START_POSITIONS_OFFSET = 120;

// utility functions

export const getAssetPathForIcon = async (characterIcon: CharacterIcon) => {
  const filePath = mapCharacterIconToFilePath(characterIcon);
  // const { default: imageAssetPath } = await import(filePath);
  return filePath;
};

const getImage = async (url: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
};

export const initializeCharacters = async (
  characters: UninitializedCharacter[]
): Promise<Character[]> => {
  const totalNumberOfCharacters = characters.length;

  const initializedCharacters: Character[] = await Promise.all(
    characters.map(async (char, index) => {
      const assetPathForIcon = await getAssetPathForIcon(char.icon);

      const image: HTMLImageElement = await getImage(assetPathForIcon);
      const IMAGE_RATIO = image.width / image.height;

      // initial positioning logic
      // (see Storybook: SceneCanvas with variable amount of Characters)
      const initialX =
        CHAR_START_POSITIONS_INITIAL_X +
        (index % 5) * CHAR_START_POSITIONS_OFFSET;
      const initialY =
        totalNumberOfCharacters > 5
          ? index > 4
            ? SVG_CANVAS_HEIGHT * (3 / 4) - CHAR_INITIAL_WIDTH / IMAGE_RATIO / 2
            : SVG_CANVAS_HEIGHT / 4 - CHAR_INITIAL_WIDTH / IMAGE_RATIO / 2
          : SVG_CANVAS_HEIGHT / 4 - CHAR_INITIAL_WIDTH / IMAGE_RATIO / 2;

      return {
        id: `char-${index + 1}`,
        name: char.name,
        icon: char.icon,
        statement: char.statement,
        role: char.role,
        assetPath: assetPathForIcon,
        width: char.width ?? CHAR_INITIAL_WIDTH,
        height: char.height ?? CHAR_INITIAL_WIDTH / IMAGE_RATIO,
        ratio: IMAGE_RATIO,
        orientation: char.orientation ?? CharacterOrientation.ORIGINAL,
        position: {
          x: char.position?.x ?? initialX,
          y: char.position?.y ?? initialY,
        },
      };
    })
  );

  return initializedCharacters;
};
